const footer = [
  {
    title: 'Quickstart',
    link: '/tutorials/getting-started/getting-started-with-react'
  },
  {
    title: 'API references',
    link: '/restapi/index'
  },
  {
    title: 'FAQ',
    link: '/faq/content-types'
  },
  {
    title: 'Contact us',
    link: 'https://www.sensenet.com/en/contact'
  },
]

module.exports = footer;
